
export const navDropdown = () => {
 const drop =  document.getElementById("navbarSupportedContent")
 drop.classList.remove("show");
}
